<div class="flex flex-row flex-wrap gap-4 justify-content-center my-3">
    <div *ngFor="let plan of subscriptionList" class="w-11rem sm:w-15rem" style="cursor: pointer;">
        <p-card styleClass="shadow-2 hover:shadow-8">
            <ng-template pTemplate="header">
                <p-image src="{{ plan.image }}"></p-image>
            </ng-template>
            <ng-template pTemplate="title">
                <span>{{ plan.name }}</span>
            </ng-template>
            <ng-template pTemplate="footer">
                <h2>${{ plan.price | number: '1.0-0' : 'co' }}</h2>
            </ng-template>
            <ng-template pTemplate="content">
                <div style="min-height: 95px;">
                    <span>{{ plan.description }}</span>
                </div>
            </ng-template>
        </p-card>
    </div>
</div>